import { useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import Cookies from 'js-cookie';

import { PATH_MAP_COOKIE_NAME } from '../constants';
import { setTimeout } from 'timers';
import { useCallOnce } from '../custom-hooks';

const QUARTER_HOUR = 1 / 96;

function replacer(key: string, value: any) {
    if (value instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(value.entries()), // or with spread: value: [...value]
        };
    } else {
        return value;
    }
}
function reviver(key: string, value: any) {
    if (typeof value === 'object' && value !== null) {
        if (value.dataType === 'Map') {
            return new Map(value.value);
        }
    }
    return value;
}
function getCookie(cookieKey: string) {
    let lStorage = new Map<string, any>();
    try {
        lStorage = Cookies.get(cookieKey)
            ? new Map(JSON.parse(Cookies.get(cookieKey) || '', reviver))
            : lStorage;
    } catch (e) {
        console.warn('Could not retrieve Map from cookie');
    }

    return lStorage;
}

function scrollToY(controlledScroll: number, retryAttempts = 3) {
    requestAnimationFrame(() => {
        window.scrollTo({ top: controlledScroll, behavior: 'smooth' });
        if (retryAttempts) {
            setTimeout(() => {
                scrollToY(controlledScroll, retryAttempts - 1);
            }, 500);
        }
    });
}

const control = getCookie(PATH_MAP_COOKIE_NAME);

export default function ScrollManager() {
    const { pathname } = useLocation();
    useCallOnce(() => {
        const zoom = window.devicePixelRatio;
        const height = document.body.offsetHeight;
        const controlKey = `${pathname}|${zoom}`;

        const fn = debounce(() => {
            const zoom = window.devicePixelRatio;
            const height = document.body.offsetHeight;
            const controlKey = `${pathname}|${zoom}`;
            const controlHeight = control.get(controlKey);

            if (height >= controlHeight) {
                control.set(controlKey, height);
                control.set(`${controlKey}|Y`, window.scrollY);
            }

            Cookies.set(PATH_MAP_COOKIE_NAME, JSON.stringify(Array.from(control), replacer), {
                expires: QUARTER_HOUR,
            });
        }, 200);

        if (control?.has(controlKey)) {
            const controlHeight = control.get(controlKey);
            const controlledScroll = control.get(`${controlKey}|Y`);

            if (height > controlHeight) {
                control.set(controlKey, height);
                scrollToY(controlledScroll, 5);
            }
        } else {
            control.set(controlKey, 0);
            window.scrollTo(0, 0);
        }

        window.addEventListener('scroll', fn);
        return () => {
            window.removeEventListener('scroll', fn);
        };
    });

    return null;
}
